"use client";
import constate from "constate";
import { useState } from "react";
import { getInvoice } from "@/app/(hub)/invoices/services";
import {
  Invoice,
  InvoiceItem,
  NewInvoiceItem,
  InvoiceStatus,
} from "@/app/(hub)/invoices/types";

function useInvoiceStore() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState<string | undefined>();
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice>();
  const [type, setType] = useState(InvoiceStatus.DRAFT);
  const [items, setItems] = useState<NewInvoiceItem[]>([]);
  const newItem = {
    name: "",
    quantity: 1,
    productId: "",
    product: {
      id: "",
      name: "",
    },
    variant: {
      id: "",
      name: "",
      price: 0,
      unit: "",
      sku: "",
    },
  };

  async function fetchInvoice(id: string) {
    const invoice: Invoice = await getInvoice(id);
    const editItems = invoice.items.map((item: InvoiceItem) => {
      return {
        ...item,
        variant: {
          id: item.variant?.id,
          name: item.variant?.name,
          price: item.variant.price / 100,
          unit: item.variant?.unit,
          sku: item.variant?.sku,
        },
        product: {
          id: item.product.id,
          name: item.product.name,
        },
        productId: item.product.id,
        quantity: item.quantity,
        name: item.product.name,
      };
    });
    setSelectedInvoice({ ...invoice, items: editItems });
    setItems([...editItems]);
  }

  return {
    open,
    setOpen,
    selected,
    setSelected,
    selectedInvoice,
    fetchInvoice,
    newItem,
    items,
    setItems,
    type,
    setType,
  };
}

export const [InvoiceProvider, useInvoiceContext] = constate(useInvoiceStore);
